import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const STEPS = [
  { n: 1, label: "Position"    },
  { n: 2, label: "Associate"   },
  { n: 3, label: "FTE & Skills"},
  { n: 4, label: "Review"      },
];

const StepIndicator = ({ current }) => {
  const theme  = useTheme();
  const t      = theme.custom;
  const isDark = theme.palette.mode === "dark";

  return (
    <Box sx={{ display: "flex", alignItems: "center", mb: "20px" }}>
      {STEPS.map((s, i) => {
        const done   = s.n < current;
        const active = s.n === current;

        return (
          <React.Fragment key={s.n}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <Box sx={{
                width: "24px", height: "24px", borderRadius: "50%",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontFamily: "'DM Mono', monospace", fontSize: "9px", fontWeight: 600,
                flexShrink: 0,
                border: "2px solid",
                background: done || active ? t.accent : "transparent",
                borderColor: done || active ? t.accent : t.border3,
                color: done || active
                  ? (isDark ? "#060E0D" : "#fff")
                  : t.text3,
                transition: "all 0.2s",
              }}>
                {done ? "✓" : s.n}
              </Box>
              <Typography sx={{
                fontFamily: "'DM Mono', monospace",
                fontSize: "8px", letterSpacing: "0.12em",
                textTransform: "uppercase",
                color: done ? t.accent : active ? t.text : t.text3,
                whiteSpace: "nowrap",
              }}>
                {s.label}
              </Typography>
            </Box>

            {i < STEPS.length - 1 && (
              <Box sx={{
                flex: 1, height: "2px", mx: "8px",
                background: done ? t.accent : t.border2,
                transition: "background 0.2s",
              }} />
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default StepIndicator;